import { postRequest } from '../../../shared/utils';

type NpiSteeringDeletionRow = {
  id1: number | string;
  zustaendiger_k_berater: number | string | null;
  planer: number | string | null;
};

type NpiSteeringRowDeletePayload = {
  screen: 'NPI_STEERING';
  rowId: number;
  pkey: 'id1';
  schemaName: 'npi';
  tableName: 'sheet1';
  screenGridId: number;
  messageKey: 'npiSteering.delete_notification_message';
  messageParams: {
    id1: string;
  };
  previousIndusId: number;
};

type CreateNpiSteeringDeletionRequestNotificationParams = {
  row: NpiSteeringDeletionRow;
  previousIndusId: number;
  screenGridId: number;
  createdBy: number;
};

function isMissingAssignment(value: number | string | null | undefined): boolean {
  if (value == null) {
    return true;
  }

  if (typeof value === 'string') {
    return value.trim() === '';
  }

  return false;
}

function parseUserId(value: number | string | null | undefined): number | null {
  if (isMissingAssignment(value)) {
    return null;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function resolveRecipients(
  row: NpiSteeringDeletionRow,
): { roleNames: string[]; userIds?: undefined } | { roleNames?: undefined; userIds: number[] } {
  const meResponsible = parseUserId(row.zustaendiger_k_berater);
  const planner = parseUserId(row.planer);

  // Case 1&2: no ME responsible or no planner -> NPI Manager role
  if (meResponsible == null || planner == null) {
    return { roleNames: ['NPI Manager'] };
  }

  // Case 3: both present -> planner user only
  return { userIds: [planner] };
}

export async function createNpiSteeringDeletionRequestNotification({
  row,
  previousIndusId,
  screenGridId,
  createdBy,
}: CreateNpiSteeringDeletionRequestNotificationParams) {
  const id1 = Number(row.id1);
  const recipients = resolveRecipients(row);

  const payload: NpiSteeringRowDeletePayload = {
    screen: 'NPI_STEERING',
    rowId: id1,
    pkey: 'id1',
    schemaName: 'npi',
    tableName: 'sheet1',
    screenGridId,
    messageKey: 'npiSteering.delete_notification_message',
    messageParams: {
      id1: String(id1),
    },
    previousIndusId,
  };

  return postRequest('/api/notification/createNotification', {
    type: 'ROW_DELETE',
    payload,
    createdBy,
    ...recipients,
    status: 'UNREAD',
    message: `Deletion requested for NPI ID ${id1}`,
  });
}
